const videos = {
    portugues: {
        msgNotLive1: 'Ansioso? Calma!',
        msgNotLive2: 'Em breve tem Live',
        msgNotLive3: 'Clique aqui para acessar nossa página inicial',        
        msgLive1: 'Acompanhe os bastidores do nosso novo ensaio em tempo real. A transmissão fica no ar por 48 horas. Lembre-se: os vídeos desta Live e um Making Of exclusivo em 4K serão lançados com o ensaio oficial.',
        msgLive2: 'Clique no PLAY para assistir. Se o vídeo não carregar, recarregue a página (F5).',
        msgLive3: '<strong>Os vídeos ficarão disponíveis para assistir durante 48 horas - após este período serão expirados.</strong>',
        msgLive4: 'Lembrando que um Making Of inédito em 4K, com cenas exclusivas e muito mais closes será lançada juntamente com o ensaio, para você se deliciar nos mínimos detalhes.',
        msgLive5: 'Clique no <strong>PLAY</strong> abaixo e assista a Live. Caso o vídeo não seja exibido, clique em "reload" (recarregar a página) ou pressione F5.',
        msgLive6: 'ASSISTA A LIVE AGORA!',
        msgLive7: 'Confira a live abaixo:',
        msgLive8: 'CLIQUE PARA VER O VÍDEO',        
        msgLive9: 'Veja Mais',
        msgLive10: 'Veja as fotos do making of',
        msgLive11: 'Em Breve',
        msgLive12: 'GOSTOU? QUER MAIS?',
        msgLive13: 'Confira outras lives abaixo:',
        msgLive14: 'Assista a Live',
        modalMsg1: 'Conteúdo exclusivo para',
        modalMsg2: 'assinantes Plus e Gold',
        modalMsg3: 'Para assistir, faça o upgrade do seu plano ou utilize créditos para download.',
        modalMsg4: 'QUERO FAZER UPGRADE',
        modalMsg5: 'USAR CRÉDITOS',
        modalMsg6: 'CONTINUAR NO BASIC',
        modalMsg7: 'CONTINUAR NO PLANO ATUAL',        
        modalMsgLive1: 'Acesso à LIVE exclusivo',
        modalMsgLive2: 'para membros Gold',
        modalMsgLive3: 'Para assistir, faça o upgrade para o Plano Gold ou utilize créditos para baixar o conteúdo.',
        modalMsgLive4: 'Para assistir em 4K, faça o upgrade do seu plano ou utilize créditos para download.',
        modalMsgLiveVideo3: 'Para assistir, faça o upgrade do seu plano e',
        modalMsgLiveVideo4: 'libere acesso às lives, making of, downloads, videos em 4K.',
        modalMsgLiveVisitor3: 'Para assistir, faça sua assinatura e',
        modalMsgLiveVisitor4: 'libere acesso às lives, making of, downloads, videos em 4K.',
        modalMsgSubscribe: 'QUERO ASSINAR',
        modalMsgAlreadyAccount: 'FAZER LOGIN',
        modalMsgContinueWanting: 'CONTINUAR NA VONTADE',
        modalMsgVideo1: 'Qualidade 4K exclusiva para',
        modalMsgVideo2: 'membros com planos Plus e Gold',
        // Janela da live: o prazo vem da API (liveAccess) e é formatado por utils/formataPrazo.
        msgLive1ComPrazo: 'Acompanhe os bastidores do nosso novo ensaio em tempo real. A transmissão fica no ar para você até {fim}. Lembre-se: os vídeos desta Live e um Making Of exclusivo em 4K serão lançados com o ensaio oficial.',
        msgPrevia: 'Pré-visualização (só admin): a live abre para os assinantes em {inicio}.',
        msgPlusAcabou1: 'Seu tempo de live no Plus acabou',
        msgPlusAcabou2: 'No Gold, ela fica no ar até {prazo}.',
        modalMsgGold1: 'Seu tempo de live no Plus acabou',
        modalMsgGold2: 'mas no Gold ela continua no ar!',
        modalMsgGold3: 'Assinantes Gold têm {horasAMais}: a live fica liberada até {prazo}.',
        modalMsgGold4: 'Faça o upgrade e volte a assistir agora.',
        modalMsgGoldButton: 'QUERO SER GOLD',
        modalMsgGoldContinue: 'CONTINUAR NO PLUS',
    },
    ingles: {
        msgNotLive1: 'Anxious? Relax!',
        msgNotLive2: 'A Live is coming soon',
        msgNotLive3: 'Click here to access our home page',
        msgLive1: 'Watch behind-the-scenes footage of our new photoshoot in real time. The live stream will be available for 48 hours. Remember: videos from this live stream and an exclusive 4K behind-the-scenes look will be released along with the official photoshoot.',
        msgLive2: 'Click PLAY to watch. If the video doesn\'t load, refresh the page (F5).',
        msgLive3: '<strong>The videos will be available to watch for 48 hours - after this period they will expire.</strong>',
        msgLive4: 'Remembering that an unprecedented Making Of in 4K, with exclusive scenes and much more close-ups will be released together as a shooting, for you to delight in the smallest details.',
        msgLive5: 'Click <strong>PLAY</strong> below and watch the Live. If the video is not displayed, click on "reload" (reload the page) or press F5.',
        msgLive6: 'WATCH THE LIVE STREAM NOW!',
        msgLive7: 'Check out the live stream below:',
        msgLive8: 'CLICK TO WATCH THE VIDEO',
        msgLive9: 'See More',
        msgLive10: 'See behind-the-scenes photos',
        msgLive11: 'Coming Soon',
        msgLive12: 'DID YOU LIKE IT? WANT MORE?',
        msgLive13: 'Check out other live streams below:',
        msgLive14: 'Watch Live',
        modalMsg1: 'Exclusive content for ',
        modalMsg2: 'Plus and Gold subscribers',
        modalMsg3: 'To watch, upgrade your plan or use download credits.',
        modalMsg4: 'I WANT TO UPGRADE',
        modalMsg5: 'USING CREDITS NOW',
        modalMsg6: 'CONTINUE ON BASIC',
        modalMsg7: 'CONTINUE ON CURRENT PLAN',
        modalMsgLive1: 'Exclusive LIVE access',
        modalMsgLive2: 'for Gold members',
        modalMsgLive3: 'To watch, upgrade to the Gold Plan or use credits to download the content.',
        modalMsgLive4: 'To watch in 4K, upgrade your plan or use download credits.',
        modalMsgLiveVideo3: 'To watch, upgrade your plan and ',
        modalMsgLiveVideo4: 'unlock access to lives, making of, downloads, 4K videos.',
        modalMsgLiveVisitor3: 'To watch, subscribe and ',
        modalMsgLiveVisitor4: 'unlock access to lives, making of, downloads, 4K videos.',
        modalMsgSubscribe: 'I WANT TO SUBSCRIBE',
        modalMsgAlreadyAccount: 'GO TO LOGIN',
        modalMsgContinueWanting: 'MAYBE LATER',
        modalMsgVideo1: 'Exclusive 4K quality for',
        modalMsgVideo2: 'Plus and Gold plan members',
        msgLive1ComPrazo: 'Watch behind-the-scenes footage of our new photoshoot in real time. The live stream is available to you until {fim}. Remember: videos from this live stream and an exclusive 4K behind-the-scenes look will be released along with the official photoshoot.',
        msgPrevia: 'Preview (admins only): the live opens to subscribers on {inicio}.',
        msgPlusAcabou1: 'Your Plus live time is over',
        msgPlusAcabou2: 'On Gold, it stays on until {prazo}.',
        modalMsgGold1: 'Your Plus live time is over',
        modalMsgGold2: "but on Gold it's still on!",
        modalMsgGold3: 'Gold members get {horasAMais}: the live stays open until {prazo}.',
        modalMsgGold4: 'Upgrade now and get back to watching.',
        modalMsgGoldButton: 'UPGRADE TO GOLD',
        modalMsgGoldContinue: 'STAY ON PLUS',
    }
  }
  
  export default videos
  